import { FC, ReactNode } from "react";
import styled from "styled-components";

interface ValueViewProps {
	label: string;
	value: ReactNode;
	className?: string;
}

const Wrapper = styled.div`
	display: grid;
	grid-template-rows: max-content max-content;
`;

const Label = styled.div`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

export const ValueView: FC<ValueViewProps> = ({ value, label, className }) => {
	return (
		<Wrapper className={className}>
			<Label>{label}</Label>
			<div>{value}</div>
		</Wrapper>
	);
};
